import { useState, useEffect } from 'react';
import { CourseCategory } from '@/types/data';

export const useCourseCategories = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getCourseCategories = async (level?: number) => {
    const courseCategories: CourseCategory[] = [];
    try {
      setLoading(true);
      setError(null);

      const url = level ? `/api/course-categories?level=${level}` : '/api/course-categories';
      const response = await fetch(url);
      const data = await response.json();

      if (data.success && data.data) {
        courseCategories.push(...data.data);
      } else {
        setError(data.error || 'Có lỗi xảy ra khi tải danh mục khóa học');
      }
    } catch (err) {
      setError('Có lỗi xảy ra khi tải danh mục khóa học');
    }
    setLoading(false);
    return courseCategories;
  };

  return {
    loading,
    error,
    getCourseCategories,
  };
};
